module.exports = __webpack_public_path__ + "static/media/Mercury.c57dbd10.png";